import React, { useEffect, useState } from 'react';
import initializeI18n from './i18n';
import { useGetAuthQuery } from '@/redux/features/usersApiSlice';

const LanguageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  const { data: getAuthInfo, isLoading, isError } = useGetAuthQuery({});

  useEffect(() => {
    if (isLoading || isError) {
      return;
    }

    const initialize = async () => {
      const template = getAuthInfo.template;
      await initializeI18n(template);
      setIsInitialized(true);
    };

    initialize();
  }, [getAuthInfo]);

  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  return <div>{children}</div>;
};

export default LanguageWrapper;
